// extracted by mini-css-extract-plugin
module.exports = {"makeSmaller":"table-row_makeSmaller__1z3P8","cell":"table-row_cell__3dWRq","hideOnMobile":"table-row_hideOnMobile__G9G3o"};